import { render, staticRenderFns } from "./SupportTickets.vue?vue&type=template&id=1c4e0530&scoped=true&"
import script from "./SupportTickets.vue?vue&type=script&lang=js&"
export * from "./SupportTickets.vue?vue&type=script&lang=js&"
import style0 from "./SupportTickets.vue?vue&type=style&index=0&id=1c4e0530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e0530",
  null
  
)

export default component.exports